if (!customElements.get('article-share')) {
  customElements.define('article-share', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.input = this.querySelector('input');
      this.onClick = this.onClick || this.copyLink.bind(this);
      this.button.hidden = false;
      this.button.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.button.removeEventListener('click', this.onClick);
    }

    async copyLink() {
      this.button.disabled = true;
      this.status.textContent = '';
      this.input.hidden = true;
      try {
        try {
          await navigator.clipboard.writeText(this.dataset.url);
          this.status.textContent = this.dataset.copied;
        } catch {
          this.status.textContent = this.dataset.manual;
          this.input.hidden = false;
          this.input.focus();
          this.input.select();
        }
      } finally {
        this.button.disabled = false;
      }
    }
  });
}
